import type { ReactNode } from 'react';
import { Icon } from '@framework/ui/atoms/Icon/Icon';
import { useNavigate } from 'react-router';
import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';

type FallbackProps = Parameters<Sentry.FallbackRender>[0];

const Fallback: React.FC<FallbackProps> = ({ resetError }: FallbackProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="absolute left-0 top-0 flex h-screen w-screen flex-col items-center justify-center">
      <div className="flex flex-col items-center">
        <Icon name="balus" color="brand" size="brand-xl" />
        <div className="mt-3 font-bold text-brand">Balus 2.0</div>

        <h2 className="my-5 text-2xl font-bold">{t('framework.error.title')}</h2>

        <p>{t('framework.apology')}</p>
        <p>{t('framework.error.notified')}</p>
        <p>{t('framework.error.retry')}</p>

        <a
          href="#"
          className="mt-5 text-brand underline"
          onClick={() => {
            resetError();
            try {
              // 過去のページに戻れない場合 (file:// の場合には戻れない) は、トップページに遷移する
              navigate(-1);
            } catch {
              navigate('/');
            }
          }}
        >
          {t('framework.error.goBack')}
        </a>
      </div>
    </div>
  );
};

type Props = {
  children: ReactNode;
};

export const ErrorBoundary: React.FC<Props> = ({ children }: Props) => {
  return <Sentry.ErrorBoundary fallback={(props) => <Fallback {...props} />}>{children}</Sentry.ErrorBoundary>;
};
